import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Storage } from "../../storage";
import { createVenueNote, updateVenueNote } from "../../apis/venue-notes";

export function useCreatePublicVenueNote() {
  const queryClient = useQueryClient();

  const { data, error, mutate, status } = useMutation({
    mutationFn: ({
        title,
        noteId,
        businessId,
        note,
        notePriority,
        noteAreaType,
        noteAreaId,
        dateFrom,
        dateTo,
      }: {
        title: string;
        noteId?: string;
        businessId: string;
        note: string;
        notePriority: string;
        noteAreaType: string;
        noteAreaId: string;
        dateFrom: string;
        dateTo: string;
      }) => {
        if (noteId) {
          return updateVenueNote({
            noteId,
            businessId,
            title,
            note,
            notePriority,
            noteAreaType,
            noteAreaId,
            dateFrom,
            dateTo,
            token: Storage.getCurrentUserToken() || "",
          });
        } else {
          return createVenueNote({
            businessId,
            title,
            note,
            notePriority,
            noteAreaType,
            noteAreaId,
            dateFrom,
            dateTo,
            token: Storage.getCurrentUserToken() || "",
          });
        }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });
    },
  });
  return {
    data,
    error,
    mutate,
    status,
  };
}
